module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<span tabindex="0">' +
((__t = ( I18n.t('uploader.source.gphotos.failed') )) == null ? '' : __t) +
'</span>\n<div id="done" class="bottom_button" tabindex="0">' +
((__t = ( I18n.t('uploader.source.gphotos.failed_button') )) == null ? '' : __t) +
'</div>\n';

}
return __p
}